import 'css-chunksrc/client/pages/zonesPage/projectsPage/loader/styles.scss';export default {
  "loader": "_loader_yrxr8_1",
  "header": "_header_yrxr8_6",
  "addZoneButton": "_addZoneButton_yrxr8_15",
  "list": "_list_yrxr8_21",
  "item": "_item_yrxr8_28"
};